import { asyncToGenerator as _asyncToGenerator, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import _regeneratorRuntime from '../node_modules/regenerator-runtime/runtime.esm.js';
import { Contract } from '@ethersproject/contracts';
import { Buffer } from 'buffer/';
import { resolveURI } from '../utils/resolveURI.esm.js';
import { fetch } from '../utils/fetch.esm.js';
import '../utils/index.esm.js';

var abi = ['function uri(uint256 _id) public view returns (string memory)', 'function balanceOf(address account, uint256 id) public view returns (uint256)'];

function getMarketplaceAPIKey(uri, options) {
  var _options$apiKey;

  if (uri.startsWith('https://api.opensea.io') && options != null && (_options$apiKey = options.apiKey) != null && _options$apiKey['opensea']) {
    return {
      'X-API-KEY': options.apiKey.opensea
    };
  }

  return false;
}

var ERC1155 = /*#__PURE__*/function () {
  function ERC1155() {}

  var _proto = ERC1155.prototype;

  _proto.getMetadata = /*#__PURE__*/function () {
    var _getMetadata = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider, ownerAddress, contractAddress, tokenID, options) {
      var tokenIDHex, contract, _yield$Promise$all, tokenURI, balance, isOwner, _resolveURI, resolvedURI, isOnChain, isEncoded, _resolvedUri, marketplaceKey, response, metadata;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // exclude opensea api which does not follow erc1155 spec
              tokenIDHex = !tokenID.startsWith('https://api.opensea.io') ? tokenID.replace('0x', '').padStart(64, '0') : tokenID;
              contract = new Contract(contractAddress, abi, provider);
              _context.next = 4;
              return Promise.all([contract.uri(tokenID), ownerAddress && contract.balanceOf(ownerAddress, tokenID)]);

            case 4:
              _yield$Promise$all = _context.sent;
              tokenURI = _yield$Promise$all[0];
              balance = _yield$Promise$all[1];
              // if user has valid address and if token balance of given address is greater than 0
              isOwner = !!(ownerAddress && balance.gt(0));
              _resolveURI = resolveURI(tokenURI, options), resolvedURI = _resolveURI.uri, isOnChain = _resolveURI.isOnChain, isEncoded = _resolveURI.isEncoded;
              _resolvedUri = resolvedURI;

              if (!isOnChain) {
                _context.next = 13;
                break;
              }

              if (isEncoded) {
                _resolvedUri = Buffer.from(resolvedURI.replace('data:application/json;base64,', ''), 'base64').toString();
              }

              return _context.abrupt("return", JSON.parse(_resolvedUri));

            case 13:
              marketplaceKey = getMarketplaceAPIKey(resolvedURI, options);
              _context.next = 16;
              return fetch.get(encodeURI(resolvedURI.replace(/(?:0x)?{id}/, tokenIDHex)), marketplaceKey ? {
                headers: marketplaceKey
              } : {});

            case 16:
              response = _context.sent;
              _context.next = 19;
              return response == null ? void 0 : response.data;

            case 19:
              metadata = _context.sent;
              return _context.abrupt("return", _extends({}, metadata, {
                is_owner: isOwner
              }));

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getMetadata(_x, _x2, _x3, _x4, _x5) {
      return _getMetadata.apply(this, arguments);
    }

    return getMetadata;
  }();

  return ERC1155;
}();

export default ERC1155;
//# sourceMappingURL=erc1155.esm.js.map
